import { Injectable } from '@angular/core';
import { ProductServiceInterface } from '@app/models/interfaces/product-service.interface';
import { TaqmanSearchResponseInterface } from '@app/models/responses/taqman-search-response.interface';
import { MicrornaPrimaryProductApiInterface } from '@app/products/microrna/microrna-primary/models/interfaces/microrna-primary-product-api.interface';
import { MicrornaPrimaryProductInterface } from '@app/products/microrna/microrna-primary/models/interfaces/microrna-primary-product.interface';

@Injectable({providedIn: 'root'})
export class MicrornaPrimaryProductService implements ProductServiceInterface {

    makeProductFromSearchResult(searchResult: TaqmanSearchResponseInterface): MicrornaPrimaryProductInterface[] {

        return searchResult.products.map((product: MicrornaPrimaryProductApiInterface) => {

            const newProduct: MicrornaPrimaryProductInterface = {
                ...product,
                selectedAvailability: product.availability, // preselect
                selectedCatalogNumber: product.defaultCatalogNum, // preselect
                selectedSize: product.defaultSize, // preselect
                taqmanProductID: product.productID // unique ID for the UI
            }

            return newProduct;

        });

    }

}
